// ═══════════════════════════════════════════════════════════════════════════
// publicidadVentanasShape — lectura de campanasMetricasVentanas (PURO)
// ═══════════════════════════════════════════════════════════════════════════
// Reporte NYeQ7WJW: el selector de ventana de Publicidad. Docs producidos por
// functions/dashboardRollups/publicidadVentanas (derivados del cuaderno diario).
// Consistencia de números: dentro de una ventana TODO sale de estos docs —
// los KPIs globales son la SUMA de las campañas de la ventana (card = tabla),
// con las MISMAS fórmulas de publicidadRollupCore (acos/roas/ctr/cpc).

export const VENTANAS_PUBLICIDAD = [
  { id: 0, label: 'Mes actual' },
  { id: 7, label: '7 días' },
  { id: 14, label: '14 días' },
  { id: 21, label: '21 días' },
  { id: 30, label: '30 días' }, // fuente actual (ventana ML del sync) — default
  { id: 60, label: '60 días' },
  { id: 90, label: '90 días' },
]

const CAMPOS_SUMA = [
  'clicks', 'prints', 'cost',
  'direct_units_quantity', 'indirect_units_quantity', 'units_quantity',
  'direct_amount', 'indirect_amount', 'total_amount',
]
const num = (v) => (v == null || Number.isNaN(Number(v)) ? 0 : Number(v))

/** Docs refTipo='campana' de la ventana → mapa porCampana (molde del rollup). */
export function porCampanaDesdeVentanas(docs = []) {
  const out = {}
  for (const d of docs) {
    if (!d || d.refExternalId == null) continue
    out[String(d.refExternalId)] = { metricas: d.metricas || {} }
  }
  return out
}

/** KPIs globales de la ventana = SUMA de sus campañas + derivados (espejo core). */
export function globalDesdeVentanas(docs = []) {
  const sum = Object.fromEntries(CAMPOS_SUMA.map((k) => [k, 0]))
  for (const d of docs) {
    const m = d?.metricas || {}
    for (const k of CAMPOS_SUMA) sum[k] += num(m[k])
  }
  return {
    ...sum,
    acos: sum.total_amount > 0 ? sum.cost / sum.total_amount : null,
    roas: sum.cost > 0 ? sum.total_amount / sum.cost : null,
    ctr: sum.prints > 0 ? sum.clicks / sum.prints : null,
    cpc: sum.clicks > 0 ? sum.cost / sum.clicks : null,
  }
}

/**
 * Metadatos declarables de la ventana: rango real, cobertura y frescura.
 * `disponible` = hay docs (el cuaderno ya alcanza esta ventana).
 * `diasConDatos` = máximo `dias` visto (cobertura honesta: "X de N días").
 * `cadencia` = la que selló el recálculo más reciente, con su `calculadoEn`
 * (report ZMBElq5SBZW4e82Z8ya3): es con la que la pantalla juzga si está vieja.
 */
export function metaDeVentana(docs = [], ventanaId = null) {
  let desde = null, hasta = null, diasConDatos = 0, calculadoEn = null, cadencia = null
  for (const d of docs) {
    if (!d) continue
    if (d.desde && (!desde || d.desde < desde)) desde = d.desde
    if (d.hasta && (!hasta || d.hasta > hasta)) hasta = d.hasta
    if (Number(d.dias) > diasConDatos) diasConDatos = Number(d.dias)
    const c = d.calculadoEn?.toDate ? d.calculadoEn.toDate() : (d.calculadoEn instanceof Date ? d.calculadoEn : null)
    if (c && (!calculadoEn || c > calculadoEn)) { calculadoEn = c; cadencia = d.cadencia ?? null }
  }
  const diasNominal = ventanaId === 0 ? diasEnMesHasta(hasta) : Number(ventanaId) || null
  return { disponible: docs.length > 0, desde, hasta, diasConDatos, diasNominal, calculadoEn, cadencia }
}

/**
 * Los días que cubre el gasto de UN doc de métricas de publicidad, o `null`.
 * Dos colecciones lo guardan distinto: `campanasMetricas` en `ventanaDias` (clave
 * lógica del doc) y `campanasMetricasVentanas` en `ventana` (0 = mes en curso, que
 * dura los días del mes que van hasta `hasta`). Un doc sin ventana legible no
 * declara cuántos días suma su gasto: devolver `null` y no 30 (report bvwlp0MPBf2X9gx58XrL).
 * @returns {number|null}
 */
export function ventanaNominalDelDoc(doc) {
  if (!doc) return null
  const propia = Number(doc.ventanaDias)
  if (Number.isFinite(propia) && propia > 0) return propia
  if (doc.ventana == null) return null
  const v = Number(doc.ventana)
  if (v === 0) return diasEnMesHasta(doc.hasta)
  return Number.isFinite(v) && v > 0 ? v : null
}

/** Días nominales del "mes actual" = día del mes de `hasta` (1..31). */
function diasEnMesHasta(hasta) {
  if (!hasta || !/^\d{4}-\d{2}-\d{2}$/.test(String(hasta))) return null
  return Number(String(hasta).slice(8, 10))
}

/** Etiqueta corta del rango de la ventana ("1/7 al 3/7"). */
export function etiquetaRangoVentana(meta) {
  if (!meta?.desde || !meta?.hasta) return ''
  const f = (iso) => `${Number(iso.slice(8, 10))}/${Number(iso.slice(5, 7))}`
  return `${f(meta.desde)} al ${f(meta.hasta)}`
}
